"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarGroupFlyoutContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _AvatarGroupFlyoutContainerStyled = require("../styled/AvatarGroupFlyoutContainerStyled");
const AvatarGroupFlyoutContainer = /*#__PURE__*/(0, _react.forwardRef)((props, parentRef) => {
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const localRef = (0, _react.useRef)(null);
  const combinedRef = (0, _lodestarUtils.useForkRef)(parentRef, localRef);
  return /*#__PURE__*/_react.default.createElement(_AvatarGroupFlyoutContainerStyled.AvatarGroupFlyoutContainerStyled, (0, _extends2.default)({}, props, {
    ref: combinedRef,
    themeMode: themeMode
    // So these can be imperatively focused.
    ,
    tabIndex: -1,
    onKeyDown: e => {
      // Prevent the Tab key from moving focus out of this container. Ideally, Tab would
      // move focus back to the Avatar that opened the Flyout, but that's not possible
      // with the current Flyout implementation since we cannot pass props directly to the
      // FlyoutContainer component override. We could probably make this work w/ React
      // context, but handling Tab here is a nice-to-have feature really and is not worth
      // the effort currently.
      if (e.key === "Tab") {
        e.preventDefault();
      }
    }
  }));
});
exports.AvatarGroupFlyoutContainer = AvatarGroupFlyoutContainer;
AvatarGroupFlyoutContainer.displayName = "AvatarGroupFlyoutContainer";
//# sourceMappingURL=AvatarGroupFlyoutContainer.js.map